import { AGE_RANGE } from "../config/const/enums";
import { calculateFullAge } from "../utilities/ageCalculation";

//------------------------------------------------------------------------------

//** We need to work out a few values based on the age */
//** of the applicant(s) so that we can set the MIN and MAX values  */
//** and the correct disclaimer */
export const ageUpdate = (person, dob, application) => {
	if (dob == null) return person;
	//* Calculate the age of the applicant
	const calAge = calculateFullAge({
		dob: dob,
		yearsAdded: 0,
	});

	//* Calculate the age when the policy matures
	const calMaturity = calculateFullAge({
		dob: dob,
		yearsAdded: 5,
	});

	//* Set the disclaimer based on age
	const ageRange =
		calMaturity.years < 65
			? AGE_RANGE.BELOW
			: calAge.years < 65 && calMaturity.years > 65
				? AGE_RANGE.WITHIN
				: AGE_RANGE.ABOVE;

	const ageRangeCC =
		calAge.years >= 65 ? AGE_RANGE.ABOVE_CC : AGE_RANGE.WITHIN_CC;

	//* Set the min age group the person belongs to
	const minAge = calAge.years <= 45 ? 16 : calAge.years >= 56 ? 56 : 46;

	//* Set the max age group the person belongs to
	const maxAge = calAge.years <= 45 ? 45 : calAge.years >= 56 ? 65 : 55;

	person.age = calAge;
	person.maturityAge = calMaturity;
	person.disclaimerAgeRange = ageRange;
	person.disclaimerAgeRangeCC = ageRangeCC;
	person.showAdditionalCover = minAge >= 56 ? false : true; // Don't offer CI or PUW cover to age range above 65.
	person.minAgeGroup = minAge;
	person.maxAgeGroup = maxAge;

	return person;
};
